module.exports = "/static/assets/82bfb019b31f069af40d1a18b7cbfb24.svg";